import WorkOrderBomLinkText from '#/modules/momMgmt/workOrder/components/WorkOrderBomLinkText';
import WorkOrderStatusBadge from '#/modules/momMgmt/workOrder/components/WorkOrderStatusBadge';
import { formatDateOrDash } from '#/utils/date';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function mtrLabel(row) {
  const mtr = row?.mtr;
  if (!mtr) {
    return '-';
  }
  return mtr.mtrNo ? `${mtr.mtrNo} ${mtr.name ?? ''}`.trim() : dash(mtr.name);
}

function bomLabel(row) {
  const bom = row?.bom;
  if (!bom) {
    return '-';
  }
  const parts = [bom.code, bom.version, bom.name].filter(Boolean);
  return parts.length ? parts.join(' · ') : '-';
}

export const workOrderSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {row?.status
            ? <WorkOrderStatusBadge status={row.status} size="sm" />
            : <p>-</p>}
        </div>
      ),
    },
  ],
};

export const workOrderSideMsgDetailBlock = {
  fields: [
    { label: '工單號', value: 'workOrderNo' },
    { label: '排程日', value: (row) => formatDateOrDash(row?.scheduledStartDate) },
    { label: '成品', value: mtrLabel },
    {
      key: 'bom',
      label: 'BOM',
      render: (row) => (
        <div className="side_msg-row">
          <h3>BOM</h3>
          <WorkOrderBomLinkText label={bomLabel(row)} bomId={row?.bom?.id} />
        </div>
      ),
    },
    { label: '加工廠', value: (row) => dash(row?.processingFactory?.name) },
    { label: '工作倉', value: (row) => dash(row?.workWarehouse?.name) },
    { label: '目標倉', value: (row) => dash(row?.targetWarehouse?.name) },
    {
      label: '製造數量',
      value: (row) => {
        const q = row?.quantity;
        if (!q) {
          return '-';
        }
        return dash(q.manufacturingQty);
      },
    },
    {
      label: '有效製造量',
      value: (row) => dash(row?.quantity?.effectiveManufacturingQty),
    },
    {
      label: '單據筆數',
      value: (row) => {
        if (!row) {
          return '-';
        }
        return `異動 ${row.amendmentCount ?? 0}／出庫 ${row.stockIssueCount ?? 0}／入庫 ${row.stockReceiptCount ?? 0}`;
      },
    },
    { label: '事由', value: 'issueReason' },
    { label: '備註', value: 'remark' },
  ],
};
